// Per-side usage control of the compatibility screen (leave-on / leave-off / auto).
import React from 'react';
import { AnimatedSwap } from './screenMotion';

export default function UsageSegmented({
  side, label, value, onChange, options,
}: {
  side: 'a' | 'b';
  label: string; value: string;
  onChange: (v: string) => void;
  options: { value: string; label: string }[];
}) {
  const cols = options.length || 1;
  const labelId = `usage-${side}-label`;
  return (
    <div className={`stack-2 compare-usage compare-usage--${side}`}>
      <div id={labelId} className="t-small compare-result-side__label" style={{ fontWeight: 600 }}>
        <span className="compare-result-side__marker" aria-hidden />{label}
      </div>
      <div
        role="radiogroup"
        aria-labelledby={labelId}
        className="grid w-full overflow-hidden compare-usage__options"
        style={{ gridTemplateColumns: `repeat(${cols}, minmax(0, 1fr))`, borderRadius: 'var(--r-sm)', border: '1px solid var(--rule)' }}
      >
        {options.map((o, i) => {
          const active = value === o.value;
          return (
            <button
              key={o.value}
              type="button"
              role="radio"
              aria-checked={active}
              tabIndex={active ? 0 : -1}
              onClick={() => { onChange(o.value); }}
              onKeyDown={(e) => {
                const dir = e.key === 'ArrowRight' || e.key === 'ArrowDown' ? 1
                  : e.key === 'ArrowLeft' || e.key === 'ArrowUp' ? -1 : 0;
                if (!dir) return;
                e.preventDefault();
                const next = (i + dir + options.length) % options.length;
                onChange(options[next].value);
                (e.currentTarget.parentElement?.children[next] as HTMLElement | undefined)?.focus();
              }}
              className={`w-full px-3 sm:px-4 py-2.5 t-small text-center whitespace-nowrap focus-visible:outline focus-visible:outline-2 focus-visible:outline-[var(--c-kivo-teal)] compare-usage__option ${active ? 'compare-usage__option--active' : ''}`}
              style={{ borderLeft: i > 0 ? '1px solid var(--rule)' : undefined }}
            >
              <AnimatedSwap value={o.label} />
            </button>
          );
        })}
      </div>
    </div>
  );
}
